const state = {
  camp_id: null,
  camp_label: null, // période ou label lisible de la campagne
};

const mutations = {
  SET_CAMP_ID: (state, id) => {
    state.camp_id = id;
  },
  SET_CAMP_LABEL: (state, label) => {
    state.camp_label = label;
  },
};

const actions = {
  set_camp({ commit }, id) {
    commit('SET_CAMP_ID', id);
  },
  set_camp_label({ commit }, label) {
    commit('SET_CAMP_LABEL', label);
  },
};

const getters = {
  camp_id: (state) => state.camp_id,
  camp_label: (state) => state.camp_label,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
